export default __webpack_public_path__ + "static/media/NovaBTS_1.82b4ff25.jpg";